module.exports = __webpack_public_path__ + "media/3.8b16bcb7.mp3";